// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum TracePath {
  Forward = 0,
  Reverse = 1,
  Lifecycle = 2,
  Config = 3,
  Health = 4,
  Auth = 5,
  Session = 6,
}
